module.exports = __webpack_public_path__ + "static/img/home-hot1.4a4385f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-hot1.png
// module id = 9XEN
// module chunks = 21